import { useTranslation } from "@i18n";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import Text from "@CubeComponents/html/Text/Text";

interface ReconciliationBannerProps {
  emptyContainersCount: number;
  unmatchedFilesCount: number;
  onViewLog: () => void;
}

const ReconciliationBanner = ({ emptyContainersCount, unmatchedFilesCount, onViewLog }: ReconciliationBannerProps) => {
  const { t } = useTranslation();

  const hasEmpty = emptyContainersCount > 0;
  const hasUnmatched = unmatchedFilesCount > 0;
  if (!hasEmpty && !hasUnmatched) {
    return null;
  }

  return (
    <div
      className="flex items-center justify-between gap-4 w-full rounded-lg px-5 py-4 bg-[color:var(--warning-surface)] border border-[color:var(--warning)]"
      role="status"
      data-testid="reconciliationBanner"
    >
      <div className="flex items-center gap-3 min-w-0">
        <span
          className="shrink-0 flex items-center justify-center w-6 h-6 rounded-full bg-[color:var(--warning-emphasis)] text-white text-sm font-bold leading-none"
          aria-hidden="true"
        >
          !
        </span>
        <div className="min-w-0 flex flex-col gap-0.5">
          <Text className="font-semibold text-[color:var(--warning-text)]">{t("Error while uploading files")}</Text>
          <div className="flex items-center gap-3 text-[0.8125rem] text-[color:var(--warning-text)] flex-wrap">
            {hasEmpty && (
              <span>
                <span className="font-semibold">{emptyContainersCount}</span> {t("containers have no files")}
              </span>
            )}
            {hasEmpty && hasUnmatched && (
              <span className="w-px h-4 bg-[color:var(--border-gray)] shrink-0" aria-hidden="true" />
            )}
            {hasUnmatched && (
              <span>
                <span className="font-semibold">{unmatchedFilesCount}</span> {t("files have no matching container")}
              </span>
            )}
          </div>
        </div>
      </div>
      <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={onViewLog} className="shrink-0">
        <Text>{t("View Logs")}</Text>
      </ButtonComponent>
    </div>
  );
};

export default ReconciliationBanner;
